import clsx from 'clsx';
import { ArrowUpRight } from 'lucide-react';
import Link from 'next/link';
import { ReactNode } from 'react';

import styles from './RelatedLinkCell.module.scss';

interface RelatedLinkCellProps {
  href: string;
  className?: string;
  singleLine?: boolean;
  children: ReactNode;
}

export const RelatedLinkCell = ({ href, className, singleLine = false, children }: RelatedLinkCellProps) => (
  <Link
    href={href}
    className={clsx(styles.link, className)}
    onClick={e => e.stopPropagation()}
    data-testid="related-link"
  >
    <span className={clsx(styles.text, singleLine && styles.single)}>{children}</span>
    <ArrowUpRight
      className={styles.icon}
      size={13}
    />
  </Link>
);
